import FormItem from "./FormItem/index.vue";
import SvgIcon from "./SvgIcon/index.vue";
import Map3D from "./Map3D/index.vue";
import Year from "./Year/index.vue";
import imgTabs from "./imgTabs/index.vue";
import HelmetBar from "./HelmetBar/index.vue";
import FlowChart from "./FlowChart/index.vue";
import ImgMap from "./ImgMap/index.vue";
import BasicSelect from "./BasicSelect/index.vue";
import HorizontalBar from "./HorizontalBar/index.vue";
import HeadSelect from "./HeadSelect/index.vue";
import ValueText from "./ValueText/index.vue";
import MixBar from "./MixBar/index.vue";
import MixBarNew from "./MixBarNew/index.vue";
import YearMonthTab from "./YearMonthTab/index.vue";
import NewMap3D from "./NewMap3D/index.vue";
import WorldMap from "./WorldMap/index.vue";
import AllAreaSelect from "./AllAreaSelect/index.vue";
import PeriodBar from "./PeriodBar/index.vue";
import TextAreaModel from "./TextAreaModel/index.vue";
import EarthMap from "./EarthMap/index.vue";
import BQH from "./BQH/index.vue";
import FullScreen from "./FullScreen/index.vue";

const components = {
  FormItem: FormItem,
  SvgIcon,
  Map3D,
  Year,
  imgTabs,
  HelmetBar,
  FlowChart,
  ImgMap,
  BasicSelect,
  HorizontalBar,
  HeadSelect,
  ValueText,
  MixBar,
  YearMonthTab,
  NewMap3D,
  WorldMap,
  MixBarNew,
  AllAreaSelect,
  PeriodBar,
  TextAreaModel,
  EarthMap,
  BQH,
  FullScreen2: FullScreen
};

export default {
  install(app) {
    for (let key in components) {
      app.component(key, components[key]);
    }
  },
};
